<template>
  <div class="form-subheader primary--text subtitle-2" v-on="$listeners">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormSubheader'
};
</script>

<style lang="sass" scoped>
.form-subheader
    height: 48px
    line-height: 48px !important
</style>
